// extracted by mini-css-extract-plugin
export default {"root":"kuRblUNmEKS8KY3hDrwr"};